import axios from "axios";

export type ConvertedBlob = {
  base64: string | ArrayBuffer;
  name: string;
  type: string;
  size: number;
  blob: string | Blob;
};

export function convertToBase64(file: string | Blob): Promise<ConvertedBlob> {
  return new Promise(async (resolve, reject) => {
    let newFile = file;
    let name: string | undefined = undefined;
    let size: number | null = null;
    let type: string | null = null;

    if (typeof newFile === "string") {
      try {
        const response = await axios.get(newFile, {
          responseType: "blob",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,HEAD",
            "Content-Type": "application/json;charset=utf-8",
          },
        });

        if (response.status && response.status === 200) {
          if (response && response.data) {
            type = response.data.type;
            name = newFile.split("/").pop();
            //@ts-ignore:next-line
            size = file.size;
            newFile = response.data;
          }
        } else {
          reject();
        }
      } catch (err) {
        reject(err);
      }
    }

    if (newFile instanceof Blob && file instanceof Blob) {
      const reader = new FileReader();

      reader.readAsDataURL(newFile);

      // console.log("file", file);
      // console.log("reader", reader);

      reader.onload = async () => {
        const typeFile = String(
          // @ts-ignore:next-line
          reader.result!.split(";")[0].split(":")[1].split("/")[0]
        ).toLowerCase();

        let dimensions = { width: 0, height: 0 };

        if (typeFile === "image") {
          dimensions = await dimensionsImage(reader.result);
        }

        resolve({
          base64: reader.result as string | ArrayBuffer,
          // @ts-ignore:next-line
          name: name || file.name,
          type: type || file.type,
          size: size || file.size,
          blob: newFile,
          ...dimensions,
        });
      };

      reader.onerror = (error) => reject(error);
    }
  });
}

export function dimensionsImage(
  base64: string | ArrayBuffer | null = ""
): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = base64 as string;

    image.onload = () => resolve({ width: image.width, height: image.height });
    image.onerror = (error) => reject(error);
  });
}
